import { createSelector } from "@reduxjs/toolkit";
import { buildScenarioGenerator } from "../../utils/scenarioFunctions";
import * as con from '../../GlobalConstants'

/**
 * Factory selector that returns a memoized generator function
 * for a given scenario id.
 *
 * @param {string} id - scenario id
 * @returns {Function} (spot, d) => number
 */

export const makeSelectScenarioGeneratorById = (id) =>
  createSelector(
    [
      (state) => state[con.REDUCER_SCENARIOS].byId[id],
      (state) => state[con.REDUCER_MARKET_VALUES][con.MARKET_VOLATILITY],
      (state) => state[con.REDUCER_MODEL_PARAMETERS][con.ESC_CONFIDENCE_LEVEL],
    ],
    (scenario, volatility, percentile) => {
      if (!scenario) return null;

      return buildScenarioGenerator(scenario, {
        volatility,
        percentile,
      });
    }
  );

export const makeMultipleSelectScenarioGeneratorsByIds = (ids) => {

  const generatorSelectors = (ids ?? []).map(id =>
    makeSelectScenarioGeneratorById(id)
  )

  return createSelector(
    [
      (state) => state[con.REDUCER_SCENARIOS].byId,
      ...generatorSelectors
    ],
    (byId, ...generators) => {

      return (ids ?? []).map((id, index) => ({
        id,
        name: byId?.[id]?.name,
        gen_fun: generators[index]
      }))
    }
  )
}